module.exports = __webpack_public_path__ + "static/media/blankletter-old.281bace4.jpg";